import Structure from '../modules/structure';

/**
 * Back to top script
 * @returns {jQuery} 
 */
$.fn.headerCatalogScript = function() {
    /**
     * @type {jQuery} - all containers affected by selector
     */
    var jqAllAffectedContainers = this;
    const screenWidth = $( window ).width();
    let iSetNonScrollabale = false;
   
    jqAllAffectedContainers.each(function() {
        const container = $(this);
        const structure = new Structure('headerCatalogScript', container, {
            button: ">a.btn"
        }).structure;
        if (screenWidth <= 1259) {
            structure.button.on('click', function(e) {
                e.preventDefault();
                let makeNonScrollabale = false;
                if (screenWidth <= 767) { //additional rules of mobile size
                    if ($('body').hasClass('non-scrollable')) {
                        if (iSetNonScrollabale) {
                            makeNonScrollabale = true;
                        }
                    } else {
                        makeNonScrollabale = true;
                    }
                }
                if (container.hasClass('open')) {
                    container.removeClass('open');
                    console.log('iSetNonScrollabale', iSetNonScrollabale, 'makeNonScrollabale', makeNonScrollabale);
                    if (iSetNonScrollabale && makeNonScrollabale) {
                        $('body').removeClass('non-scrollable');
                        iSetNonScrollabale = false;
                    }
                } else {
                    container.addClass('open');
                    if (makeNonScrollabale) {
                        $('body').addClass('non-scrollable');
                        iSetNonScrollabale = true;
                    }
                }
                
            })
        }
    });

    return jqAllAffectedContainers;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.header-catalog-js').headerCatalogScript();
});
